import { render, staticRenderFns } from "./VueNestable.vue?vue&type=template&id=20b4e7e2&"
import script from "./VueNestable.vue?vue&type=script&lang=js&"
export * from "./VueNestable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../exo_admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports